/** Display ratios — source assets live in /public/countries */
export const COUNTRY_CARD_ASPECT = "1 / 1";
export const COUNTRY_HERO_ASPECT = "1 / 1";

const BASE = "/countries";

/** slug → WebP filename (kebab-case) */
export const COUNTRY_IMAGE_FILES = {
    mauritius: "mauritius.webp",
    guyana: "british-guiana.webp",
    "trinidad-tobago": "trinidad.webp",
    jamaica: "jamaica.webp",
    grenada: "grenada.webp",
    "saint-lucia": "saint-lucia.webp",
    "saint-kitts": "saint-kitts.webp",
    "saint-vincent": "saint-vincent.webp",
    nevis: "nevis.webp",
    "south-africa": "south-africa.webp",
    fiji: "fiji.webp",
    malaysia: "malaysia.webp",
    "east-africa": "east-africa.webp",
    seychelles: "seychelles.webp",
    reunion: "reunion-france.webp",
    suriname: "suriname.webp",
};

export const DEFAULT_COUNTRY_IMAGE = `${BASE}/fiji.webp`;

export const countryImagePath = (slug) => {
    const file = COUNTRY_IMAGE_FILES[slug];
    return file ? `${BASE}/${file}` : DEFAULT_COUNTRY_IMAGE;
};

export { mediaPath as countryImageSrc } from "@/lib/media";

/** Attach cardImage + heroImage on each country record */
export function applyCountryImages(countries) {
    return countries.map((c) => {
        const image = countryImagePath(c.slug);
        return {
            ...c,
            cardImage: image,
            heroImage: image,
        };
    });
}
